export class DialogRevertCnModel{
    constructor(
      public data: any
    ) {}
  }
  